<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.editRoadRules") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: var(--main_theme_clr)">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <!-- <base-image-upload-input
            col="12"
            identifier="road_rule_image"
            :preSelectedImage="data.image.path"
            :placeholder="$t('PLACEHOLDERS.image')"
            @selectImage="selectImage"
          /> -->
          <!-- End:: Image Upload Input -->

          <!-- Start:: Country Select -->
          <base-select-input
            col="12"
            :optionsList="countriesList"
            :placeholder="$t('PLACEHOLDERS.country')"
            v-model="data.country_id"
            required
          />
          <!-- End:: Country Select -->

          <!-- Start:: Title Inputs -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.titleAr')"
            v-model.trim="data.name"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.titleEn')"
            v-model.trim="data.nameEn"
            required
          />
          <!-- End:: Title Inputs -->

          <!-- Start:: Description Inputs -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descAr')"
            v-model.trim="data.descProd"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descEn')"
            v-model.trim="data.descProdEn"
            required
          />
          <!-- End:: Description Inputs -->

          <!-- Start:: Active Switch -->
          <div class="input_wrapper switch_wrapper my-5 col-4">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Active Switch -->

          <!-- Start:: Submit Button -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";

export default {
  name: "EditRoadRules",
  components: { BaseImageUploadInput },

  data() {
    return {
      isWaitingRequest: false,
      countriesList: [],
      data: {
        image: {
          path: null,
          file: null,
        },
        name: null,
        nameEn: null,
        descProd: null,
        descProdEn: null,
        active: true,
        country_id: null,
      },
    };
  },

  methods: {
    // Fetch countries for select input
    async getCountries() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: "countries",
          params: {
            page: 0,
            limit: 0,
          },
        });
        this.countriesList = res.data.data.data;
      } catch (error) {
        this.$message.error(
          error.response?.data?.message || "Error fetching countries"
        );
      }
    },

    // Handle image selection
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    // Validate all inputs before submission
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.country_id) {
        this.$message.error(this.$t("VALIDATION.country"));
        this.isWaitingRequest = false;
        return;
      }

      if (!this.data.name) {
        this.$message.error(this.$t("VALIDATION.title_ar"));
        this.isWaitingRequest = false;
        return;
      }

      if (!this.data.nameEn) {
        this.$message.error(this.$t("VALIDATION.title_en"));
        this.isWaitingRequest = false;
        return;
      }

      if (!this.data.descProd) {
        this.$message.error(this.$t("VALIDATION.descAr"));
        this.isWaitingRequest = false;
        return;
      }

      if (!this.data.descProdEn) {
        this.$message.error(this.$t("VALIDATION.descEn"));
        this.isWaitingRequest = false;
        return;
      }

      this.submitForm();
    },

    // Submit form data (PUT request)
    async submitForm() {
      const REQUEST_DATA = new FormData();

      REQUEST_DATA.append("title[ar]", this.data.name);
      REQUEST_DATA.append("title[en]", this.data.nameEn);
      REQUEST_DATA.append("description[ar]", this.data.descProd);
      REQUEST_DATA.append("description[en]", this.data.descProdEn);

      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }

      if (this.data.country_id) {
        REQUEST_DATA.append("country_id", this.data.country_id.id);
      }

      REQUEST_DATA.append("_method", "PUT");
      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);

      try {
        await this.$axios({
          method: "POST",
          url: `road-rules/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/road-rules/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(
          error.response?.data?.message || "Error updating road rule"
        );
      }
    },

    // Fetch existing road rule data
    async showRoadRule() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `road-rules/${this.$route.params.id}`,
        });

        const rule = res.data.data.RoadRule;

        // this.data.image.path = rule.image;
        this.data.name = rule.title_ar;
        this.data.nameEn = rule.title_en;
        this.data.descProd = rule.description_ar;
        this.data.descProdEn = rule.description_en;
        this.data.active = rule.is_active;
        this.data.country_id = rule.country;
      } catch (error) {
        this.$message.error(
          error.response?.data?.message || "Error fetching road rule"
        );
      }
    },
  },

  async created() {
    await this.getCountries();
    this.showRoadRule();
  },
};
</script>

<style lang="scss">
.add_another {
  border: 1px solid var(--main_theme_clr);
  padding: 8px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 18px;
  color: var(--main_theme_clr);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: auto !important;
}
</style>
